import * as moment from "moment-timezone";
import firebase from "@firebase/app";
import "@firebase/firestore";

export default {
  timestampToMoment(timestamp) {
    let date = new Date(timestamp.seconds * 1000);
    let dateMoment = moment(date).tz("America/Sao_Paulo");
    return dateMoment;
  },
  async toMoment(fields) {
    // console.log(
    //   firebase.firestore.Timestamp(fields._seconds, fields._nanoseconds)
    // );
    if (fields instanceof firebase.firestore.Timestamp)
      return moment(fields.toDate());
    for (const i in fields) {
      if (fields[i] instanceof firebase.firestore.Timestamp) {
        fields[i] = moment(fields[i].toDate());
        continue;
      }
      if (
        fields[i].constructor === [].constructor ||
        fields[i].constructor === {}.constructor
      ) {
        fields[i] = toMoment(fields[i]);
      }
    }
    return fields;
  }
};
